<ng-container *ngIf="group">
    <a mat-menu-item role="list-item" *ngFor="let sample of group.samples"
        (click)="removeGroupSample(group.key, sample.key); $event.stopPropagation();"
        matTooltip="Remove Sample">
        <mat-icon svgIcon="common:{{ sample.type }}_sample"></mat-icon>
        <span matLine><strong>{{ sample.code }}</strong></span>&nbsp;
        <span matLine>{{ sample.label }}</span>&nbsp;
    </a>
</ng-container>
